// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type CheckoutReviewAndSubmit = {
    hasEmpty: boolean;
    carrierSelected: boolean;
};

const initialState: CheckoutReviewAndSubmit = {
    hasEmpty: true,
    carrierSelected: false,
};

const xCheckoutReviewAndSubmit = createTypedReducerWithImmer(initialState, {
    "xCheckoutReviewAndSubmit/updateHasEmpty": (
        draft: Draft<CheckoutReviewAndSubmit>,
        action: { hasEmpty: boolean },
    ) => {
        draft.hasEmpty = action.hasEmpty;
    },
    "xCheckoutReviewAndSubmit/carrierSelected": (
        draft: Draft<CheckoutReviewAndSubmit>,
        action: { carrierSelected: boolean },
    ) => {
        draft.carrierSelected = action.carrierSelected;
    },
});

(reducers as any).xCheckoutReviewAndSubmit = xCheckoutReviewAndSubmit;

export type xCheckoutReviewAndSubmit = {
    xCheckoutReviewAndSubmit: CheckoutReviewAndSubmit;
} & ApplicationState;

type CheckoutReviewAndSubmitReducer = {
    checkoutReviewAndSubmit: typeof xCheckoutReviewAndSubmit;
};

export type CheckoutReviewAndSubmitActions =
    | Parameters<CheckoutReviewAndSubmitReducer[keyof CheckoutReviewAndSubmitReducer]>[1]
    | AnyAction;
